export default function (context, title) {
    context.state.title = title;
    document.head.querySelector('title').innerHTML = title;
    MagTemplate.title = title;
}
